import React, { useMemo, useState, useEffect } from 'react'

interface IInputBox {
  title: string
  fromYear: number
  maxWidth?: number
  value?: number
  onChange: (value: number) => void
  style?: React.CSSProperties
}

export default function InputYearDropdown({ title, fromYear, maxWidth, value, onChange, style }: IInputBox) {
  const currentYear = new Date().getFullYear()
  const [internalValue, setInternalValue] = useState<number>(value ?? currentYear)

  useEffect(() => {
    // Hvis parent ikke har angivet en værdi, sæt indeværende år
    if (value === undefined) {
      onChange(currentYear)
    } else {
      setInternalValue(value)
    }
  }, [value, currentYear, onChange])

  const boxContainer: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    maxWidth,
    minWidth: maxWidth,
    ...style,
  }

  const labelStyle: React.CSSProperties = {
    fontSize: 16,
    color: '#333',
    fontWeight: 500,
    marginBottom: 4,
  }

  const selectStyle: React.CSSProperties = {
    borderRadius: 12,
    border: '2px solid #ccc',
    padding: '6px 16px 6px 8px',
    fontSize: 18,
    color: '#222',
    outline: 'none',
    transition: 'all 0.2s ease',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    backgroundColor: 'white',
    textAlign: 'right',
    textAlignLast: 'right' as any,
  }

  const selectFocusStyle: React.CSSProperties = {
    ...selectStyle,
    border: '2px solid #3B82F6',
    boxShadow: '0 0 0 3px rgba(59,130,246,0.25)',
  }

  const [focused, setFocused] = useState(false)

  // generér årstal fra fromYear → indeværende år
  const years = useMemo(() => {
    const list: number[] = []
    for (let y = fromYear; y <= currentYear + 1; y++) list.push(y)
    return list.reverse() // nyeste først
  }, [fromYear, currentYear])

  return (
    <div style={boxContainer}>
      <label style={labelStyle}>{title}</label>
      <select
        value={internalValue}
        onChange={e => {
          const selected = Number(e.target.value)
          setInternalValue(selected)
          onChange(selected)
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={focused ? selectFocusStyle : selectStyle}
      >
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  )
}
